var common = require("../../utiles/common.js")

module.exports = {
    register: function () {
        document.createElement('shop-list')
        ko.components.register('shop-list', {
            viewModel: function (params) {
                var $this = this;
                // $this.appData = common.fetch("/auth/app/showMyapp").data;
                // $this.activeType = ko.observable("ALL");
                $this.step = ko.observable(params.step);
            },
            template: require("./template/ShopList.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/shopList/ShopList.js
// module id = 119
// module chunks = 0